import HomeHeader from '../../components/home/header/HomeHeader'
import FoundersComponent from '../../components/founders/FoundersComponent'
import HomeFooter from '../../components/home/footer/HomeFooter'
import './FoundersPage.css'

const FoundersPage = () => {
  return (
    <div>
      <div className='header-container'>
        <HomeHeader isHeaderLeft={true} showLoginButton={true} showSignupButton={true}/>
      </div>
      <div style={{ paddingTop: '70px'}}>
        {/* put inside the founders page here */}
        <FoundersComponent/>
      </div>
      <div style={{ background: 'black', color: 'white' }}>
        <HomeFooter />
      </div>
    </div>
  );
}

export default FoundersPage;